import { useNavigate } from "react-router-dom";
import "./payment-success.css";

export default function PaymentSuccess() {
  const navigate = useNavigate();

  const handleContinueToDashboard = () => {
    navigate("/dashboard");
  };

  return (
    <div className="payment-success-status-container">
      <div className="payment-success-status-card payment-success-success">
        <div className="payment-success-success-icon">
          <svg width="80" height="80" viewBox="0 0 89 68" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5.5 41.9632L21.88 59.996C22.4327 60.6109 23.141 61.1108 23.9515 61.4581C24.762 61.8049 25.6539 61.9904 26.56 61.9996C27.4515 62.0089 28.3342 61.847 29.1438 61.5275C29.9533 61.2074 30.6694 60.7368 31.24 60.1501L83.5 6"
              stroke="#05A315"
              strokeWidth="11"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <h1>Payment Successful!</h1>
        <p className="payment-success-success-message">
          Congratulations! You are now upgraded to
          <br />
          <strong>HOMESHIKSHA PREFERRED CUSTOMER</strong>
        </p>

        <div className="payment-success-benefits-section">
          <h3>Your Benefits:</h3>
          <ul>
            <li>✓ First priority for tutor assignments</li>
            <li>✓ Dedicated Customer Relationship Manager</li>
            <li>✓ Free tutor replacements for 6 months</li>
            <li>✓ Unlimited tutor requests during subscription period</li>
            <li>✓ 100% refundable if we can't provide suitable tutor</li>
          </ul>
        </div>

        <div className="payment-success-action-buttons">
          <button className="payment-success-primary-btn" onClick={handleContinueToDashboard}>
            Continue to Dashboard
          </button>
        </div>

        <div className="payment-success-next-steps">
          <h4>What's Next?</h4>
          <p>Our team will contact you within 1-2 working hours to proceed with tutor selection.</p>
        </div>
      </div>
    </div>
  );
}
